










































import { Component, Mixins, Watch, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { debounce } from 'lodash'

// Models
import Proover from '@/models/Proover'

// Mixins
import Errors from '@/mixins/Errors'
import Table from '@/mixins/Table'
import Filters from '@/mixins/Filter'


@Component
export default class ProoversList extends Mixins(Table, Filters, Errors) {
  // Pagination
  offset = 0
  limit = 20
  end = false
  prooverSearch = null

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale

  // @ts-ignore
  @Watch('prooverSearch')
  updateSearch = debounce(async function(value) {
    this.offset = 0
    await this.fetch(false)
  }, 500)

  get params(): {} {
    const params = {
      limit: this.limit,
      offset: this.offset,
      search: this.prooverSearch
    }

    return params
  }

  selectProover(proover) {
    this.$emit('select', proover)
  }

  async fetch(add: boolean) {
    try {
      this.tableLoading = true
      const res = await this.$api.proovers.fetchProovers(this.token, this.params)
      const proovers = res.data.map((proover) => new Proover(proover, this.locale))

      this.data = add ? [...this.data, ...proovers] : proovers
      this.end = proovers.length === 0
      // this.end = proovers.length === 0 || proovers.length < this.limit
      this.offset += this.limit
    } finally {
      this.tableLoading = false
    }
  }

  async mounted() {
    await this.fetch(false)
    const res = await this.$api.proovers.fetchProovers(this.token, this.params)
    this.firstLoad = false
    this.hasData = res.data.length > 0
  }

  async loadMore() {
    await this.fetch(true)
  }
}
